type Props = {
  label: string;
  name?: string;
  required?: boolean;
  style?: any;
};

export default function Label({ label, name, required, style }: Props) {
  return (
    <label
      htmlFor={name}
      className={`block text-input text-gray-700`}
      style={style}
    >
      {label} {required && <span className={`text-red-600`}>*</span>}
    </label>
  );
}
